import Sortable from "sortablejs";

export default function(el, binding) {
    let params = binding.value || {}
    if (typeof params != 'object') {
        throw new Error('Must be object, not ' + (typeof params))
    }
    let sortable = Sortable.create(el, params);
}


// WEBPACK FOOTER //
// ./src/webpack/vue/components/sortable.js